import { TeamMembers } from '../interfaces/User';
import { useGetQuery } from './useGetQuery';

interface GetUserPermissionsParams {
    search?: string;
    page: number;
    size: number;
}

export const useTeamMembers = (params: GetUserPermissionsParams) => {
    const { isLoading, entries: users, refetch, paging } = useGetQuery<{
        data: TeamMembers[];
    }>({
        url: '/team-members',
        cacheKey: 'team-members',
        params: { ...params }
    });

    return { isLoading, teamMembers: users.data || [], refetch, paging };
};
